import ProgramPageWrapper from "./ProgramPageWrapper";
import ProgramPageInformation from "./ProgramPageInformation";

export default [
  {
    path: "/program_pages/:id",
    component: ProgramPageWrapper,
    children: [
      {
        path: "",
        name: "program_page_info",
        component: ProgramPageInformation,
        meta: {
          toolbar: "program_page",
          tabAccess: "DATABASE",
        },
      },
    ],
  },
];
